import React from "react";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { LEGAL } from "../data/legal";
type Props = {
  doc: keyof typeof LEGAL;
  path: string;
};
export function LegalPage({
  doc,
  path
}: Props) {
  const data = LEGAL[doc];
  useSeo({
    title: data.title,
    description: data.description,
    path
  });
  return <>
      <PageHero crumbs={[{
      label: data.title
    }]} eyebrow="Legal" title={data.title} lead={data.description} data-id="element-756" data-mp="1zez6kobe3mmb" />
      <section className="shell section" data-id="element-757" data-mp="2r7ykd40554t3">
        <div className="grid gap-x-[clamp(2rem,5vw,7rem)] lg:grid-cols-[minmax(220px,0.5fr)_1.5fr]" data-id="element-758" data-mp="2r91bnd1dl99j">
          {data.sections.map(s => <React.Fragment key={s.heading} data-id="element-759" data-mp="2n87mkgc75of2">
              <h2 className="border-t border-line pt-6 font-display text-xl font-semibold tracking-tight lg:pb-10" data-id="element-760" data-mp="2i832yhfzsdkm">{s.heading}</h2>
              <p className="t-body max-w-[70ch] pb-10 pt-3 text-fg-2 lg:border-t lg:border-line lg:pt-6" data-id="element-761" data-mp="1bssn95wimkgs">{s.body}</p>
            </React.Fragment>)}
        </div>
      </section>
    </>;
}